import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#FFFFFF !important",
    borderBottom: "1px solid rgba(0,0,0,0.08)",
    overflow: "hidden",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    padding: "8px 24px",
    maxWidth: "100%",
    width: "100%",
    minHeight: "64px !important",
    boxSizing: "border-box",
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      padding: "8px 16px",
    },
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    flexShrink: 1,
    minWidth: 0,
    overflow: "hidden",
  },
  centerSection: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    padding: "0 16px",
    minWidth: 0,
    overflow: "hidden",
    [theme.breakpoints.down("lg")]: {
      padding: "0 12px",
    },
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexShrink: 0,
  },
  flex: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  font700: {
    fontWeight: 700,
  },
  ml: {
    marginLeft: "8px",
  },
  linkDecoration: {
    textDecoration: "none",
    alignSelf: "center",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  iconButton: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    transition: "all 0.2s ease",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.04)",
    },
  },
}));

export default useStyles;
